const event_tickets = {
  id: 'ID du billet',
  ticket_identifier: 'Numéro du billet',
  status: 'Statut du billet',
  sold_price: 'Prix de vente',
  first_name: 'Prénom (billet)',
  last_name: 'Nom (billet)',
  email: 'Courriel (billet)',
  phone: 'Téléphone (billet)',
  invoice_id: 'ID de la facture',
  payment_status: 'Statut du paiement',
  is_sent_by_email: 'Envoyé par courriel',
  is_sent_by_sms: 'Envoyé par SMS',
};

export default event_tickets;
